import styled from "styled-components"

export const StyledMealListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 0px;
  gap: var(--spacing_xl, 24px);
`

export const FoodLeft = styled.div`
  display: flex;
  gap: 8px;
  flex-grow: 1;
  max-width: calc(100% - 32px - 24px);
`

export const FoodImageBox = styled.div`
  height: 34px;
  width: 34px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--Schemes-Primary-Container-Variant, #cceded);
  flex-shrink: 0;
  overflow: hidden;
`

export const FoodInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 40px - 8px - 32px - 24px);
  flex-grow: 1;
  cursor: default;
  gap: 4px;
`

export const FoodNameBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--spacing_xs, 6px);
`

export const FoodName = styled.p`
  font-size: 14px;
  color: var(--Schemes-On-Surface, #1c1f21);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 17px;

  .high-light-text {
    background-color: transparent;
    font-weight: 600;
  }
`

export const FoodNutrient = styled.div`
  color: var(--Schemes-On-Surface-Variant, #69757d);
  font-size: 12px;
  font-weight: 500;
  line-height: 12px; /* 100% */
  letter-spacing: 0.12px;
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`

export const AddFoodButton = styled.div`
  display: flex;
  padding: var(--spacing_xxs, 4px);
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 20px;
  width: 32px;
  height: 32px;
  background: var(--Schemes-Surface-Container-Low, #f5f7f7);
  flex-shrink: 0;
  background: rgb(245, 247, 247);
  cursor: pointer;
`

export const FoodListDivider = styled.div`
margin: 4px 0;
height: 1px;
background: var(--Schemes-Outline, rgba(0, 38, 58, 0.14));
width: 100%;

@supports (-webkit-touch-callout: none) {
  height: 0.8px;
`

export const FoodBottomInfo = styled.div`
  height: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
`

export const MealUnitAndPortionBox = styled.div`
  display: flex;
  align-items: center;
  color: var(--Schemes-Surface-On-surface-On-Surface-Variant-2, #69757d);
`

export const FoodBrand = styled.div`
  border-radius: 2px;
  background: var(--Schemes-Surface-Container, #ebedf0);
  display: flex;
  padding: 1px 4px 0px 4px;
  align-items: center;
  height: 15px;

  p {
    font-weight: 500;
    font-size: 12px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #69757d;
  }
`
